import * as React from "react";
import * as _ from "lodash";
import { Modal, Button, Table } from "react-bootstrap";
import { IDutyOfficerSchedule, IContact } from "@nkr/models/index";
import { IDay, ITimeSlot } from "./models";
import AddEditTimeSlotRow from "./add-edit-timeslot-row";

interface IProps {
    show: boolean,
    data: ITimeSlot[],
    days: IDay[],
    hours: number[],
    officers: IContact[],
    existing: IDutyOfficerSchedule[],
    onSave: (list: ITimeSlot[]) => void
    onUpdate: (item: ITimeSlot) => void,
    onCancel: () => void
}

interface IState {
    list: ITimeSlot[],
    valid: boolean
}

class AddEditTimeSlot extends React.Component<IProps, IState> {
    readonly state: IState = {
        list: [],
        valid: false
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show && !this.props.show) {
            const officers = nextProps.officers || [];
            const firstOfficerId = officers[0]?.id;
            const list = (nextProps.data || []).map(slot => {
                const slotCopy = _.cloneDeep(slot);
                if (officers.length && (!slotCopy.officerId || !officers.some(o => o.id === slotCopy.officerId))) {
                    slotCopy.officerId = firstOfficerId;
                }
                return slotCopy;
            });
            this.setState({ list });
        }
    }

    handleDayChange = (index: number, day: number) => {
        let list = _.cloneDeep(this.state.list).map((item, i) => {
            if (i == index) {
                item.day = day;
            }

            return item;
        });

        let validatedList = this.validateList(list);

        this.setState({ list: validatedList });
    }

    handleStartTimeChange = (index: number, startTime: string, startTimeRaw: number) => {
        let list = _.cloneDeep(this.state.list).map((item, i) => {
            if (i == index) {
                item.startTime = startTime;
                item.startTimeRaw = startTimeRaw;
            }

            return item;
        });

        let validatedList = this.validateList(list);

        this.setState({ list: validatedList });
    }

    handleEndTimeChange = (index: number, endTime: string, endTimeRaw: number) => {
        let list = _.cloneDeep(this.state.list).map((item, i) => {
            if (i == index) {
                item.endTime = endTime;
                item.endTimeRaw = endTimeRaw;
            }

            return item;
        });

        let validatedList = this.validateList(list);

        this.setState({ list: validatedList });
    }

    handleOfficerChange = (index: number, officerId: number) => {
        let list = _.cloneDeep(this.state.list).map((item, i) => {
            if (i == index) {
                item.officerId = officerId;
            }

            return item;
        });

        this.setState({ list });
    }

    handleSave = () => {
        if (this.state.list.length == 1 && this.state.list[0].id > 0)
            this.props.onUpdate(this.state.list[0]);
        else
            this.props.onSave(this.state.list);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    validateList = (list: ITimeSlot[]) => {
        let validatedList = _.cloneDeep(list).map((slot, index) => {
            let filteredOverlappingExisting = this.props.existing.filter(x => x.id != slot.id && x.dayId == slot.day);

            let overlappingExisting = filteredOverlappingExisting.filter(x => {
                let startInRange = slot.startTimeRaw >= x.startTimeRaw && slot.startTimeRaw <= x.endTimeRaw;
                let endInRange = slot.endTimeRaw >= x.startTimeRaw && slot.endTimeRaw <= x.endTimeRaw;
                return startInRange || endInRange;
            });

            let filteredOverlappingNew = list.filter((x, i) => index != i && x.day == slot.day);

            let overlappingNew = filteredOverlappingNew.filter((x, i) => {
                let startInRange = slot.startTimeRaw >= x.startTimeRaw && slot.startTimeRaw <= x.endTimeRaw;
                let endInRange = slot.endTimeRaw >= x.startTimeRaw && slot.endTimeRaw <= x.endTimeRaw;
                return startInRange || endInRange;
            });

            slot.overlap = overlappingExisting.length > 0 || overlappingNew.length > 0;

            return slot;
        });

        return validatedList;
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const title = this.state.list.length == 1 && this.state.list[0].id > 0 ? 'Edit Timeslot' : 'Add Timeslot(s)';
        const valid = this.state.list.filter(x => x.overlap).length == 0;

        return (
            <>
                <Modal show={this.props.show} onHide={this.handleCancel}>
                    <Modal.Header closeButton>{title}</Modal.Header>

                    <Modal.Body>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Start</th>
                                    <th>End</th>
                                    <th>Officer</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((timeSlot, index) =>
                                    <AddEditTimeSlotRow
                                        key={index}
                                        index={index}
                                        data={timeSlot}
                                        days={this.props.days}
                                        officers={this.props.officers}
                                        hours={this.props.hours}
                                        onOfficerChange={this.handleOfficerChange}
                                        onDayChange={this.handleDayChange}
                                        onStartTimeChange={this.handleStartTimeChange}
                                        onEndTimeChange={this.handleEndTimeChange}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.handleSave} disabled={!valid}>Save</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default AddEditTimeSlot;